module.exports = __webpack_public_path__ + "static/media/3d-controls-icon.08d0eeac.svg";